import React, { useState, useEffect, useCallback, useContext } from 'react';
import { useForm } from 'react-hook-form';
import AlertContext from '../../../GlobalComponents/Alert/contexts/alertContext';

//import global components
import { Card, Modal, ModalActionConfirm } from '../../../../imports';

//import services
import { EditarProyecto, EliminarProyecto, AgregarProyectoIndividual } from '../../../../servicios/ServicioProyecto';

//import icons from heroicons
import { PlusCircleIcon, UserIcon, DocumentTextIcon, PencilIcon, XMarkIcon, CheckCircleIcon, BriefcaseIcon, CalendarIcon } from '@heroicons/react/24/outline';

export default function Proyectos({
    validationMessages,
    userData,
    setUserData,
    finalData,
    setFinalData,
    allowEdit,
    listProjectsByPerson,
    isFirstLoadProject,
    setIsFirstLoadProject,
    projectDataEdit,
    setProjectDataEdit,
    idCurriculum
}) {

    //use alert context
    const alertCtx = useContext(AlertContext);

    //here we pass a default input property to save in userData
    //all inputs use this same event in 'onchange'
    const handleChange = (e) => {
        const { name, value } = e.target;
        setValue(name, e.target.value)
    };

    //use react hook form to get values and make validations
    const { register, reset, getValues, setValue, handleSubmit, formState } = useForm({
        mode: 'all',
        defaultValues: {
            projectName: '',
            companyName: '',
            projectDescription: '',
            startDate: '',
            finishDate: ''
        }
    });

    const modalStyle = {
        background: 'transparent',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        margin: 0
    };

    const { errors } = formState;

    //use to get validations from props and later iterate
    const [validations, setValidations] = useState([]);

    const [showModal, setShowModal] = useState(false);

    //use modal and show for save
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [actionTypeConfirmModal, setActionTypeConfirmModal] = useState("");
    const [showConfirmEditModal, setShowConfirmEditModal] = useState(false);

    const [listProjects, setListProjects] = useState([]);

    const [currentIdCard, setCurrentIdCard] = useState(null);

    const [idFromCard, setIdFromCard] = useState(0);

    //validate if user already complete cv
    const userCompleteCV = sessionStorage.getItem("USER_COMPLETE_CV");

    const [userSaveActionSuccess, setUserSaveActionSuccess] = useState(false);

    const [dataIndividualProject, setDataIndividualProject] = useState({});

    //call services to delete elements from education
    async function EliminarProyectoPersona(idProyecto) {
        const response = await EliminarProyecto(idProyecto);
        return response;
    }

    //method to add new project
    const AgregarProyectoPersona = async (e) => {
        const ProyectosData = {
            nombreProyecto: dataIndividualProject.dataForGlobalList?.projectName,
            nombreEmpresa: dataIndividualProject.dataForGlobalList?.companyName,
            fechaInicio: dataIndividualProject.dataForGlobalList?.startDate === "" ? null : dataIndividualProject.dataForGlobalList?.startDate,
            fechaFin: dataIndividualProject.dataForGlobalList?.finishDate === "" ? null : dataIndividualProject.dataForGlobalList?.finishDate,
            descripcionProyecto: dataIndividualProject.dataForGlobalList?.projectDescription,
            idPersona: idCurriculum
        }

        const proyectosResponse = await AgregarProyectoIndividual(ProyectosData);

        if (proyectosResponse.indicador === 0) {
            if (currentIdCard) {
                if (listProjects?.length > currentIdCard - 1 && listProjects[currentIdCard] !== undefined) {
                    for (let item of Object.keys(listProjects)) {
                        if (listProjects[item] === listProjects[currentIdCard]) {
                            listProjects[item] = dataIndividualProject
                        }
                    }
                }
            } else {
                setListProjects([...listProjects, dataIndividualProject])
            }

            alertCtx.success(proyectosResponse.mensaje);
            setUserSaveActionSuccess(true);
            setShowConfirmSaveModal(false);
            setDataIndividualProject({});
            setCurrentIdCard(null);
            setShowModal(false);
        }
    }

    //method to edit project from person by id
    const EditarProyectoPersona = async (e) => {
        const ProyectosData = {
            idProyecto: dataIndividualProject.dataForGlobalList?.idProject,
            nombreProyecto: dataIndividualProject.dataForGlobalList?.projectName,
            nombreEmpresa: dataIndividualProject.dataForGlobalList?.companyName,
            fechaInicio: dataIndividualProject.dataForGlobalList?.startDate === "" ? null : dataIndividualProject.dataForGlobalList?.startDate,
            fechaFin: dataIndividualProject.dataForGlobalList?.finishDate === "" ? null : dataIndividualProject.dataForGlobalList?.finishDate,
            descripcionProyecto: dataIndividualProject.dataForGlobalList?.projectDescription,
            idPersona: idCurriculum
        }

        const proyectosResponse = await EditarProyecto(ProyectosData);

        if (proyectosResponse.indicador === 0) {
            if (currentIdCard) {
                if (listProjects?.length > currentIdCard - 1 && listProjects[currentIdCard] !== undefined) {
                    for (let item of Object.keys(listProjects)) {
                        if (listProjects[item] === listProjects[currentIdCard]) {
                            listProjects[item] = dataIndividualProject
                        }
                    }
                }
            } else {
                setListProjects([...listProjects, dataIndividualProject])
            }

            alertCtx.success(proyectosResponse.mensaje);
            setUserSaveActionSuccess(true);
            setShowConfirmEditModal(false);
            setDataIndividualProject({});
            setCurrentIdCard(null);
            setShowModal(false);
        }
    }

    //function to save 'projects' in list
    const SaveProjectsOptions = () => {
        const startDate = getValues("startDate");
        const finishDate = getValues("finishDate");
        const projectName = getValues("projectName");
        const companyName = getValues("companyName");
        const projectDescription = getValues("projectDescription");

        // Validar campos requeridos manualmente
        if (!projectName || !companyName || !projectDescription) {
            alertCtx.error("Por favor complete todos los campos requeridos");
            return;
        }

        if (startDate === "" && finishDate === "") {
            alertCtx.error("Por favor ingrese las fechas");
            return;
        } else if (startDate > finishDate && finishDate !== "") {
            alertCtx.error("La fecha de finalización debe ser mayor a la fecha de inicio");
            return;
        } else {
            const projectName = getValues("projectName");
            const companyName = getValues("companyName");
            const projectDescription = getValues("projectDescription");
            const startDate = getValues("startDate");
            const finishDate = getValues("finishDate");

            const dataForGlobalList = {
                projectName: projectName,
                companyName: companyName,
                projectDescription: projectDescription,
                startDate: startDate,
                finishDate: finishDate,
                idProject: idFromCard
            }

            const object = {
                "dataHeader": {
                    "Proyecto": projectName,
                },
                "dataBody": {
                    "Empresa": companyName,
                },
                "dataFooter": {
                    "Descripción": projectDescription,
                },
                "dataID": {
                    "idProyecto": idFromCard
                },
                "dataForGlobalList": dataForGlobalList
            }

            if (userCompleteCV === "true") {
                setDataIndividualProject(object);
                if (actionTypeConfirmModal === "Agregar") setShowConfirmSaveModal(true);
                if (actionTypeConfirmModal === "Editar") setShowConfirmEditModal(true);
                resetAllInputs();
            } else {
                if (currentIdCard) {
                    if (listProjects?.length > currentIdCard - 1 && listProjects[currentIdCard] !== undefined) {
                        for (let item of Object.keys(listProjects)) {
                            if (listProjects[item] === listProjects[currentIdCard]) {
                                listProjects[item] = object
                            }
                        }
                    }
                } else {
                    setListProjects([...listProjects, object])
                }
                resetAllInputs();
                setCurrentIdCard(null);
                setShowModal(false);
                alertCtx.success("Datos guardados temporalmente");
                setIdFromCard(0);
            }
        }
    }

    const resetAllInputs = () => {
        reset({
            projectName: "",
            companyName: "",
            projectDescription: "",
            startDate: "",
            finishDate: "",
        }, {
            keepErrors: false,
            keepDirty: false,
        })
    }

    function setValuesById(list) {
        if (!list || !list.dataForGlobalList) return;

        setValue("projectName", list.dataForGlobalList?.projectName || "")
        setValue("companyName", list.dataForGlobalList?.companyName || "")
        setValue("projectDescription", list.dataForGlobalList?.projectDescription || "")
        setValue("startDate", list.dataForGlobalList?.startDate || "")
        setValue("finishDate", list.dataForGlobalList?.finishDate || "")
        setIdFromCard(list?.dataID?.idProyecto || 0);
    }

    //create custom object with list by person id to render cards
    const customObjectByPersonList = useCallback(() => {
        listProjectsByPerson.map((item) => {
            const startMonth = new Date(item?.fechaInicio).getMonth() + 1;
            const startYear = new Date(item?.fechaInicio).getFullYear();
            const startDay = new Date(item?.fechaInicio).getDay();
            const startDateFormatted = `${startYear}-${startMonth}-${startDay}`;
            const startDate = new Date(startDateFormatted)

            const endMonth = new Date(item?.fechaFin).getMonth() + 1;
            const endYear = new Date(item?.fechaFin).getFullYear();
            const endDay = new Date(item?.fechaFin).getDay();
            const endDateFormatted = `${endYear}-${endMonth}-${endDay}`;
            const endDate = new Date(endDateFormatted)

            const dataForGlobalList = {
                projectName: item?.nombreProyecto,
                companyName: item?.nombreEmpresa,
                projectDescription: item?.descripcionProyecto,
                startDate: item?.fechaInicio ? startDate.toLocaleDateString('fr-CA') : "",
                finishDate: item?.fechaFin ? endDate.toLocaleDateString('fr-CA') : "",
                idProject: item?.idProyecto
            }

            const object = {
                "dataHeader": {
                    "Proyecto": item?.nombreProyecto,
                },
                "dataBody": {
                    "Empresa": item?.nombreEmpresa,
                },
                "dataFooter": {
                    "Descripción": item?.descripcionProyecto,
                },
                "dataID": {
                    "idProyecto": item?.idProyecto
                },
                "dataForGlobalList": dataForGlobalList
            }

            if (listProjects !== undefined) {
                listProjects.push(object);
            }
        })
    }, [listProjectsByPerson, listProjects])

    useState(() => {
        setValidations(validationMessages);
    }, [])

    useEffect(() => {
        if (userCompleteCV === "true" && isFirstLoadProject || allowEdit === true && isFirstLoadProject) {
            if (listProjectsByPerson?.length > 0) {
                customObjectByPersonList();
                if (isFirstLoadProject) setIsFirstLoadProject(false)
            }
        }

        if (userCompleteCV === "true" || allowEdit === true) {
            if (listProjects?.length > 0) {
                if (projectDataEdit) {
                    setProjectDataEdit(listProjects);
                }
            } else {
                if (projectDataEdit) {
                    setListProjects(projectDataEdit);
                }
            }
        } else {
            if (listProjects?.length > 0) {
                if (userData) {
                    setUserData({ ...userData, "listProjects": listProjects })
                    setFinalData(userData);
                }
            } else {
                if (userData["listProjects"]) {
                    setListProjects(userData["listProjects"])
                }
            }
        }

        if (userCompleteCV === "true" && !showModal || allowEdit === true && !showModal) {
            const timeout = setTimeout(() => {
                if (projectDataEdit) {
                    setProjectDataEdit(listProjects);
                }
            }, 1000);
            return () => clearTimeout(timeout);
        } else if (!showModal) {
            const timeout = setTimeout(() => {
                if (listProjects) {
                    if (userData) {
                        setUserData({ ...userData, "listProjects": listProjects });
                        setFinalData(userData);
                    }
                }
            }, 1000);
            return () => clearTimeout(timeout);
        }

        return (() => {
            if (userCompleteCV === "true" || allowEdit === true) {
                if (isFirstLoadProject) {
                    setIsFirstLoadProject(false);
                }
                if (projectDataEdit) {
                    setProjectDataEdit(listProjects);
                }
            } else {
                if (listProjects) {
                    setUserData({ ...userData, "listProjects": listProjects });
                }
            }
            setShowModal(false);
        })
    }, [showModal, listProjects, userSaveActionSuccess, dataIndividualProject, actionTypeConfirmModal])

    return (
        <div className="w-full flex flex-col md:flex-row items-center justify-center px-1 mx-auto lg:py-0">
            <div className={userCompleteCV === "false" ? "w-full pt-1 bg-white rounded-lg shadow" : "w-full pt-1"}>
                <div className="relative container mx-auto items-center justify-center">
                    {listProjects?.length === 0 && userCompleteCV === "true" && !allowEdit && (
                        <div className="flex justify-center items-center mb-4 px-2 space-x-2">
                            <div className="flex-shrink-0">
                                <BriefcaseIcon className="h-8 w-8 mr-2 text-red-RS" />
                            </div>
                            <div>
                                <h1 className="font-bold font-base">Esta información es requerida para tomar en cuenta su Curriculum Vitae</h1>
                            </div>
                        </div>
                    )}

                    {!allowEdit && listProjects?.length === 0 && (
                        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                            <h1 className="text-decoration-line: underline">Por favor, presione Agregar para completar el apartado de proyectos</h1>
                        </div>
                    )}

                    {/* ADMINISTRADOR - Usar el mismo estilo de Card que el usuario */}
                    {allowEdit && listProjects?.length > 0 && (
                        <div className="container flex flex-wrap w-full py-4 mt-2 mx-auto items-start justify-center">
                            {listProjects?.map((item, index) => (
                                <div className="w-full m-0 mt-2 p-1 py-6 md:w-96" key={index}>
                                    <Card
                                        id={index}
                                        data={item}
                                        list={listProjects}
                                        setList={setListProjects}
                                        setCurrentIdCard={setCurrentIdCard}
                                        setShowModal={setShowModal}
                                        setValuesById={setValuesById}
                                        allowEdit={allowEdit}
                                        listByPerson={listProjectsByPerson}
                                        userCompleteCV={userCompleteCV}
                                        deleteElementCV={EliminarProyectoPersona}
                                        setActionTypeConfirmModal={setActionTypeConfirmModal}
                                        title="Proyectos"
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    {/* USUARIO - Mostrar tarjetas con opciones de edición */}
                    {!allowEdit && listProjects?.length > 0 && (
                        <div className="container flex flex-wrap w-full py-4 mt-6 mx-auto items-start justify-center">
                            {listProjects?.map((item, index) => (
                                <div className="w-full m-1 mt-8 p-1 py-6 md:w-96" key={index}>
                                    <Card
                                        id={index}
                                        data={item}
                                        list={listProjects}
                                        setList={setListProjects}
                                        setCurrentIdCard={setCurrentIdCard}
                                        setShowModal={setShowModal}
                                        setValuesById={setValuesById}
                                        allowEdit={allowEdit}
                                        listByPerson={listProjectsByPerson}
                                        userCompleteCV={userCompleteCV}
                                        deleteElementCV={EliminarProyectoPersona}
                                        setActionTypeConfirmModal={setActionTypeConfirmModal}
                                        title="Proyectos"
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    {/* BOTÓN AGREGAR - Solo visible en modo usuario (no admin) */}
                    {!allowEdit && (
                        <div>
                            {listProjects?.length > 0 ? (
                                <div className="flex absolute top-0 right-0 md:justify-center items-center mb-8 px-2 py-6">
                                    <button
                                        className="bg-greenButton hover:bg-primary-700 text-white text-sm py-2 px-4 rounded inline-flex items-center"
                                        onClick={() => {
                                            resetAllInputs();
                                            setShowModal(true);
                                            setActionTypeConfirmModal("Agregar");
                                        }}
                                    >
                                        <span>Agregar</span>
                                        <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                                    </button>
                                </div>
                            ) : (
                                <div className="flex justify-center items-center mb-4 px-2 py-2">
                                    <button
                                        className="bg-greenButton hover:bg-primary-700 text-white text-sm py-2 px-4 rounded inline-flex items-center"
                                        onClick={() => {
                                            resetAllInputs();
                                            setShowModal(true);
                                            setActionTypeConfirmModal("Agregar");
                                        }}
                                    >
                                        <span>Agregar</span>
                                        <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                                    </button>
                                </div>
                            )}
                        </div>
                    )}

                    {/* MODALES DE CONFIRMACIÓN */}
                    <Modal isVisible={showConfirmSaveModal} onClose={() => { setShowConfirmSaveModal(false) }} handleSubmit={() => null} onSaveOptions={null} showFotter={false} showCloseIcon={false}>
                        <ModalActionConfirm onSaveAction={AgregarProyectoPersona} actionType={actionTypeConfirmModal} setshowConfirmModal={setShowConfirmSaveModal} />
                    </Modal>

                    <Modal isVisible={showConfirmEditModal} onClose={() => { setShowConfirmEditModal(false) }} handleSubmit={() => null} onSaveOptions={null} showFotter={false} showCloseIcon={false}>
                        <ModalActionConfirm onSaveAction={EditarProyectoPersona} actionType={actionTypeConfirmModal} setshowConfirmModal={setShowConfirmEditModal} />
                    </Modal>

                    {/* MODAL DE PROYECTOS - Solo visible en modo usuario */}
                    {!allowEdit && (
                        <Modal
                            isVisible={showModal}
                            onClose={() => { setShowModal(false); resetAllInputs(); }}
                            onSaveOptions={SaveProjectsOptions}
                            showFotter={false}
                            showCloseIcon={false}
                            insideContainer={{ className: "bg-transparent", style: modalStyle }}
                        >
                            <div className="bg-white rounded-3xl p-8 border border-gray-200/80 shadow-xl shadow-gray-200/30 w-full max-w-4xl mx-auto">
                                {/* Cabecera del modal */}
                                <div className="flex justify-between items-center mb-8 pb-4 relative">
                                    <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-[#B93C2F] via-[#D37267] to-transparent"></div>
                                    <div className="absolute bottom-0 left-0 w-1/3 h-1 bg-[#B93C2F] blur-sm opacity-50"></div>

                                    <div className="flex items-center gap-3">
                                        <div className="relative">
                                            <div className="absolute -inset-2 bg-gradient-to-r from-[#B93C2F] to-[#D37267] rounded-2xl opacity-20 blur-sm"></div>
                                            <div className="absolute -inset-1 border-2 border-[#B93C2F]/20 rounded-2xl"></div>
                                            <div className="relative bg-[#FFE5E1] p-3 rounded-2xl text-[#B93C2F] shadow-lg shadow-red-500/20">
                                                <BriefcaseIcon className="h-7 w-7" />
                                            </div>
                                        </div>
                                        <div className="relative">
                                            <h2 className="text-2xl font-extrabold text-[#3C2E2C] tracking-tight">Proyectos</h2>
                                            <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-[#B93C2F] to-transparent"></div>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => { setShowModal(false); resetAllInputs(); }}
                                        className="p-2 rounded-xl hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-all duration-300 hover:rotate-90"
                                    >
                                        <XMarkIcon className="h-5 w-5" />
                                    </button>
                                </div>

                                <form onSubmit={(e) => { e.preventDefault(); SaveProjectsOptions(); }} className="space-y-5">
                                    {/* Nombre del Proyecto */}
                                    <div className="flex flex-col space-y-1.5">
                                        <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                            <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                            Nombre del proyecto
                                        </label>
                                        <div className="relative group">
                                            <input
                                                type="text"
                                                name="projectName"
                                                {...register("projectName", { required: true, maxLength: 150 })}
                                                id="projectName"
                                                placeholder="Nombre del proyecto"
                                                className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 hover:border-gray-300 pr-12"
                                            />
                                            <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-300 group-hover:text-[#B93C2F] transition-colors duration-300">
                                                <UserIcon className="h-5 w-5" />
                                            </div>
                                        </div>
                                        {validations.projectName?.map((values) => (
                                            errors.projectName?.type === values.type &&
                                            <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                        ))}
                                    </div>

                                    {/* Nombre de la empresa y fechas en 2 columnas */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="flex flex-col space-y-1.5">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                Nombre de la empresa
                                            </label>
                                            <div className="relative group">
                                                <input
                                                    type="text"
                                                    name="companyName"
                                                    {...register("companyName", { required: true, maxLength: 150, pattern: /^[\wÀ-ÿ\u00f1\u00d1]+(\s*[\wÀ-ÿ\u00f1\u00d1]*)*[\wÀ-ÿ\u00f1\u00d1]+$/ })}
                                                    id="companyName"
                                                    placeholder="Nombre de la empresa"
                                                    className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 hover:border-gray-300 pr-12"
                                                />
                                                <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-300 group-hover:text-[#B93C2F] transition-colors duration-300">
                                                    <UserIcon className="h-5 w-5" />
                                                </div>
                                            </div>
                                            {validations.companyName?.map((values) => (
                                                errors.companyName?.type === values.type &&
                                                <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                            ))}
                                        </div>

                                        <div className="flex flex-col space-y-1.5">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                Fecha inicio
                                            </label>
                                            <input
                                                type="date"
                                                name="startDate"
                                                {...register("startDate", { required: true })}
                                                id="startDate"
                                                className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 cursor-pointer hover:border-gray-300"
                                            />
                                            {validations.startDate?.map((values) => (
                                                errors.startDate?.type === values.type &&
                                                <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Fecha finalización y descripción en 2 columnas */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="flex flex-col space-y-1.5">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                Fecha finalización
                                            </label>
                                            <input
                                                type="date"
                                                name="finishDate"
                                                {...register("finishDate", { required: true })}
                                                id="finishDate"
                                                className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 cursor-pointer hover:border-gray-300"
                                            />
                                            {validations.finishDate?.map((values) => (
                                                errors.finishDate?.type === values.type &&
                                                <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                            ))}
                                        </div>

                                        <div className="flex flex-col space-y-1.5">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                Descripción del proyecto
                                            </label>
                                            <div className="relative group">
                                                <textarea
                                                    name="projectDescription"
                                                    id="projectDescription"
                                                    {...register("projectDescription", { required: true, maxLength: 255 })}
                                                    rows="3"
                                                    placeholder="Descripción del proyecto"
                                                    className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 hover:border-gray-300 pr-12 resize-none"
                                                />
                                                <div className="absolute right-4 top-4 text-gray-300 group-hover:text-[#B93C2F] transition-colors duration-300">
                                                    <DocumentTextIcon className="h-5 w-5" />
                                                </div>
                                            </div>
                                            {validations.projectDescription?.map((values) => (
                                                errors.projectDescription?.type === values.type &&
                                                <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Separador */}
                                    <div className="relative my-6">
                                        <div className="absolute inset-0 flex items-center">
                                            <div className="w-full border-t-2 border-gray-200/60"></div>
                                        </div>
                                        <div className="relative flex justify-center">
                                            <span className="px-4 bg-white">
                                                <span className="flex items-center gap-2 text-xs text-gray-400 font-mono">
                                                    <span className="w-4 h-0.5 bg-gradient-to-r from-[#B93C2F] to-[#D37267]"></span>
                                                    ◆
                                                    <span className="w-4 h-0.5 bg-gradient-to-l from-[#B93C2F] to-[#D37267]"></span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>

                                    {/* Botones */}
                                    <div className="flex justify-end gap-4 pt-2">
                                        <button
                                            type="button"
                                            onClick={() => { setShowModal(false); resetAllInputs(); }}
                                            className="px-8 py-3 bg-white border-2 border-gray-200 rounded-2xl text-sm font-bold text-[#D37267] hover:bg-red-50 hover:border-[#D37267] transition-all duration-300 shadow-sm hover:shadow-md"
                                        >
                                            Cancelar
                                        </button>

                                        <button
                                            type="submit"
                                            className="px-8 py-3 bg-[#006E4E] hover:bg-[#005c41] text-white rounded-2xl text-sm font-bold flex items-center gap-2 transition-all duration-300 shadow-lg shadow-emerald-800/20 hover:shadow-emerald-800/30"
                                        >
                                            <CheckCircleIcon className="h-5 w-5" />
                                            Confirmar
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </Modal>
                    )}
                </div>
            </div>
        </div>
    );
}